import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faUsers,
  faUser,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import UserCard from "./UserCard";
import AllUsersSection from "./AllUsersSection";
import AllGroupsSection from "./AllGroupsSection";
import { formatDateOnly } from "../../utils/DateTimeUtil";

function AccountOverview({
  accountStructure,
  showAllUsers,
  showAllGroups,
  onToggleAllUsers,
  onToggleAllGroups,
  onCreateGroupClick,
  onUserAssignmentClick,
  onGroupUpdate,
  createGroupLoading,
  getAllUsers,
  getAllGroups,
}) {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return formatDateOnly(dateString, "short");
  };

  return (
    <div className="common-section">
      <div className="common-section-header">
        <h3>
          <FontAwesomeIcon icon={faBuilding} />
          Account Overview
        </h3>
        <p>View your account information and summary statistics</p>
      </div>
      <div className="common-section-content">
        <div className="common-form-group">
          <h4>Account Information</h4>
          <div className="account-info-grid">
            <div className="info-item">
              <label>Account Name:</label>
              <span>{accountStructure.account.name}</span>
            </div>
            <div className="info-item">
              <label>Description:</label>
              <span>
                {accountStructure.account.description || "No description"}
              </span>
            </div>
            <div className="info-item">
              <label>Account Status:</label>
              <span
                className={`status ${
                  accountStructure.account.isActive ? "active" : "inactive"
                }`}
              >
                {accountStructure.account.isActive ? "Active" : "Inactive"}
              </span>
            </div>
            <div className="info-item">
              <label>Created:</label>
              <span>{formatDate(accountStructure.account.createdAt)}</span>
            </div>
          </div>
        </div>

        <div className="common-form-group">
          <div className="summary-header">
            <h4>Summary Statistics</h4>
            <button
              className="common-button"
              onClick={onCreateGroupClick}
              disabled={true}
              title="Create New Group (Disabled)"
            >
              <FontAwesomeIcon icon={faPlus} />
              New Group
            </button>
          </div>
          <div className="account-info-grid">
            <div className="info-item">
              <label>Organizations:</label>
              <span>
                <FontAwesomeIcon
                  icon={faBuilding}
                  className="summary-stat-icon"
                />
                {accountStructure.summary.totalOrganizations} Organization
                {accountStructure.summary.totalOrganizations !== 1 ? "s" : ""}
              </span>
            </div>
            <div className="info-item">
              <label>Groups:</label>
              <span
                className="summary-stat-clickable"
                onClick={onToggleAllGroups}
                title="Click to view all groups"
              >
                <FontAwesomeIcon icon={faUsers} className="summary-stat-icon" />
                {accountStructure.summary.totalGroups} Group
                {accountStructure.summary.totalGroups !== 1 ? "s" : ""}
                {showAllGroups ? " (Hide)" : " (Show All)"}
              </span>
            </div>
            <div className="info-item">
              <label>Total Users:</label>
              <span
                className="summary-stat-clickable"
                onClick={onToggleAllUsers}
                title="Click to view all users"
              >
                <FontAwesomeIcon icon={faUser} className="summary-stat-icon" />
                {accountStructure.summary.totalUsers} User
                {accountStructure.summary.totalUsers !== 1 ? "s" : ""}
                {showAllUsers ? " (Hide)" : " (Show All)"}
              </span>
            </div>
          </div>
        </div>

        {accountStructure.account.owner && (
          <div className="common-form-group">
            <h4>Account Owner</h4>
            <UserCard
              user={accountStructure.account.owner}
              onUserAssignmentClick={onUserAssignmentClick}
            />
          </div>
        )}

        {/* All Groups Summary */}
        {showAllGroups && (
          <AllGroupsSection
            groups={getAllGroups()}
            onUserAssignmentClick={onUserAssignmentClick}
            onGroupUpdate={onGroupUpdate}
          />
        )}

        {/* All Users Summary */}
        {showAllUsers && (
          <AllUsersSection
            users={getAllUsers()}
            onUserAssignmentClick={onUserAssignmentClick}
          />
        )}
      </div>
    </div>
  );
}

export default AccountOverview;
